import type { FC } from 'react';
import { NOT_AVAILABLE_DASH } from '../constants';

type FieldWithFallbackProps = {
    value?: string;
    fallback?: string;
    suffix?: string;
};

export const FieldWithFallback: FC<FieldWithFallbackProps> = ({ value, suffix = '', fallback = NOT_AVAILABLE_DASH }) => (
    <>{value ? `${value}${suffix}` : fallback}</>
);
